// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608211034/js/" + chunkId + "." + {"44":"1cecc2d3","225":"4d7f2ac3","481":"5ce7d2e9","486":"d5298593","770":"ef004ff6"}[chunkId] + ".0.8593547896149993.chunk.js";
};